import styled from 'styled-components'
import Typography from '@mui/material/Typography'
import MuiSettingsIcon from '@mui/icons-material/Settings'
import TrueChip from '../TrueChip'
import { CSVLink } from 'react-csv'
// import ClearIcon from '@mui/icons-material/Clear'
import MUITable from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import { Button } from '@mui/material'

export const Wrapper = styled.div`
  display: ${({ $flex }) => $flex ? 'inline-flex' : 'block'};
  flex-direction: column;
  min-width: 100%;
`

export const Toolbar = styled.div`
  align-items: center;
  display: flex;
  background: ${props => props.bg};
  box-sizing: border-box;
  color: ${props => props.color};
  justify-content: space-between;
  padding: 0.5rem 1rem;
  min-height: 46.75px;

  div {
    font-weight: bold;
    font-size: 0.9rem !important;
  }

  width: 100%;
`

export const ToolbarIcons = styled.div`
  position: ${({ $absolute }) => $absolute ? 'sticky' : 'static'};
  right: ${({ $absolute }) => $absolute ? '1rem' : 'auto'};
  display: flex;
  align-items: center;
  gap: .5rem;
`

export const BulkActions = styled.div`
  align-items: flex-end;
  display: flex;
  padding: 1rem 0;
`

export const BulkAndChildren = styled.div`
  align-items: flex-end;
  display: flex;
  padding: 1rem 0;
`

export const SelectAll = styled(Typography)`
  border-left: 1px solid #eee;
  margin-left: 1rem !important;
  padding-left: 1rem;
`

export const SelectAllLink = styled(Button)`
  cursor: pointer;
`

export const SettingsIcon = styled(MuiSettingsIcon)`
  margin-left: auto;
`

export const ExportLink = styled(CSVLink)`
  color: #000;
  text-decoration: none;
`

export const TrueIcon = TrueChip

export const FalseIcon = styled.span``

export const Table = styled(MUITable)`
  th {
    position: relative;
  }

  &.resizable-active > thead th,
  &.resizable-active > tbody td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.resizable-active > thead th span {
    position: static;
  }

  &.resizable-active > thead th.th-col-name span {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.resizable-active > thead th.th-col-name svg {
    position: absolute;
    right: 0;
    top: 8px;
    background: inherit !important;
    margin-left: 0;
    padding-right: 4px;
    margin-right: 0;
    padding-left: 4px;
  }

  .resizer {
      border-right: 2px solid ${({ theme }) => theme.palette.resizableBorder.main};
      height: 50%;
      position: absolute;
      top: 25%;
      right: 0;
      width: 5px;
      cursor: col-resize;
      user-select: none;
  }

  .resizer:hover,
  .resizing {
      border-right: 2px solid #A32427;
  }
`

export const Tr = styled(TableRow)`
  ${(props) => props['data-no-border'] && '> * { border-bottom: 0px solid !important; }'};

  &:hover {
    td {
      background: ${({ theme }) => theme.palette.trHover.main} !important;
    }
  }
`
